import { useSnackbar } from 'notistack';
export function useEnqueueSnackbar() {
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var enqueueMessages = function (message, variant) {
        enqueueSnackbar(message, {
            variant: variant,
            persist: false,
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
        });
    };
    return {
        enqueueMessages: enqueueMessages,
    };
}
//# sourceMappingURL=useEnqueueSnackbar.js.map